<template>
  <TemplateAnimalDetail v-if="animal" :breadcrumbs="breadcrumbs" :page="animal" />
</template>

<script setup lang="ts">
import { getIndirectClientHeaders, seoHead } from '~/assets/seo'
import { getBreadcrumbs, getSiteConfig } from '~/composables/craft'
import { useSeoRedirect } from '~/composables/seo-redirect'
import { setCacheControlHeader, setPageCacheControlHeader } from '~/composables/util'
import { useRoute } from 'vue-router'
import { useNavigationStore } from '~/store/navigation'
import { useGlobalStore } from '~/store/global'
import { useAnimalStore } from '~/store/animal'
import { useShelterStore } from '~/store/shelter'

/** Routes will be split on the '~~' characters {@see nuxt/app/router.options.ts} */
false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    nl: '/ikzoekbaas/asieldier/[categorySlug]/[id]-[name]~~/mijndieriszoek/[mdizCategory]/[categorySlug]/[id]-[name]',
  },
})

const route = useRoute()
const navigationStore = useNavigationStore()
const globalStore = useGlobalStore()
const animalStore = useAnimalStore()
const shelterStore = useShelterStore()
const config = useRuntimeConfig()
const seoRedirect = useSeoRedirect()
let breadcrumbs = null

const { site } = getSiteConfig(route)

const [, seoGlobal, animal] = await Promise.all([
  navigationStore.fetch(site),
  globalStore.fetchSeo(),
  animalStore.fetch(route.params.id, true, { headers: getIndirectClientHeaders(), notFoundStrategy: config.environment !== 'dev' ? 'ignore' : undefined }),
])

if (!animal) {
  setCacheControlHeader(600, true)
  const redirect = await seoRedirect(site, route.fullPath)
  if (redirect === false) {
    throw createError({ statusCode: 404, message: 'Page not found', fatal: true })
  }
} else if (route.path.endsWith('/')) {
  /**
   * [DB-748] This URL format is defined by Nuxt (the CMS is only queried by `[id]`), so Nuxt must
   * canonicalize a trailing slash itself: redirect to the URL without it, keeping the query string.
   */
  setCacheControlHeader(600, true)
  await navigateTo(route.path.replace(/\/+$/, '') + route.fullPath.slice(route.path.length), { redirectCode: 301, replace: true })
} else {
  // Populate store with shelter details
  await shelterStore.fetch({ site: animal.site.handle, push: true })

  setPageCacheControlHeader(animal)

  breadcrumbs = getBreadcrumbs(route, animal, [{ label: animal.animalCategory?.title, url: animal.animalCategory?.url }])

  useHead(() => seoHead(animal, seoGlobal))
}
</script>
